import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import type { PhoneNumber } from 'honeygrid-types'

export const phoneNumbersQueryKey = (workspaceId: string) => ['phone-numbers', workspaceId] as const

/**
 * Hook to fetch all phone numbers for a workspace
 */
export const usePhoneNumbers = (workspaceId?: string) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<PhoneNumber[]>({
		queryKey: phoneNumbersQueryKey(workspaceId ?? ''),
		queryFn: async (): Promise<PhoneNumber[]> => {
			return await authFetch(`workspaces/${workspaceId}/phone-numbers`)
		},
		enabled: !!workspaceId,
	})
}
